export const regexName = /^[^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{1,100}$/;
export const regexExpirationDate = /^(0[1-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})$/;
